<!-- TEMPLATE -->
<template>
  <span :class="deanTableItemClass">
    <dean-icon
      class="dean-table-item-icon"
      :glyph="glyph"
      :height="height"
      :width="width"
    >
    </dean-icon>
    <slot></slot>
  </span>
</template>

<!-- SCRIPT -->
<script lang="ts">
// VUE
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

// COMPONENTS
import deanIcon from './deanIcon.vue';

@Component({
  components: {
    deanIcon
  }
})

// CLASS
export default class deanTableItem extends Vue {
  @Prop() glyph!: object;
  @Prop({ default: false }) link!: boolean;
  @Prop({ default: '15' }) height!: string;
  @Prop({ default: '15' }) width!: string;

  get deanTableItemClass() {
    let value = 'dean-table-item';
    if (this.link) value += ` dean-table-item-link`;
    return value;
  }
}
</script>

<!-- STYLE -->
<style lang="scss" scoped>
// IMPORT
@import '../scss/vars';

// DEAN TABLE ITEM
.dean-table-item {
  display: inline-flex;
  fill: var(--color-dark-shade-4, $color-dark-shade-4);
  text-decoration: none;
  overflow-wrap: break-word;
  @include hyphens(auto);
  @include transition(all ease 0.8s);
  vertical-align: middle;
}
.dean-table-item-icon {
  margin-right: 5px;
}

.dean-table-item-link {
  font-weight: 500;
  cursor: pointer;
  color: var(--color-link, $color-link);
  fill: var(--color-link, $color-link);
  &:hover {
    color: var(--color-link-shade-2, $color-link-shade-2);
    fill: var(--color-link-shade-2, $color-link-shade-2);
  }
}
</style>
